import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import {
  generateBrandsInsightStrategy,
  generateEmojiInsightStrategy,
  generateHashtagsInsightStrategy,
  generatePeopleInsightStrategy,
  generateProductNameInsightStrategy,
  generateSentimentInsightStrategy,
  generateStarRatingsInsightStrategy,
  generateSurveyScoresInsightStrategy,
  generateTermsInsightStrategy,
  generateThingsInsightStrategy
} from 'utils/insightModal/strategy/searchFilterComposing'
import {
  pivotProductDecorator,
  pivotTagDecorator,
  pivotThemeDecorator
} from 'utils/insightModal/strategy/searchFilterComposing/decorator'
import { SideBySideWidgetsType } from '../../types'

const useSearchFilterComposingStrategy = (viewOption: InsightViewOptionStrings) =>
  useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.BRANDS:
        return generateBrandsInsightStrategy()

      case InsightViewOption.EMOJIS_GROUP:
      case InsightViewOption.EMOJIS_EMOTION:
      case InsightViewOption.EMOJIS_EMOJI:
        return generateEmojiInsightStrategy()

      case InsightViewOption.HASHTAGS:
        return generateHashtagsInsightStrategy()

      case InsightViewOption.PEOPLE:
        return generatePeopleInsightStrategy()

      case InsightViewOption.PRODUCT_NAME:
        return generateProductNameInsightStrategy()

      case InsightViewOption.ATTRIBUTES:
      case InsightViewOption.BEHAVIORS:
      case InsightViewOption.EMOTIONS:
        return generateSentimentInsightStrategy()

      case InsightViewOption.STAR_RATINGS:
        return generateStarRatingsInsightStrategy()

      case InsightViewOption.SURVEY_SCORES:
        return generateSurveyScoresInsightStrategy()

      case InsightViewOption.TERMS:
        return generateTermsInsightStrategy()

      case InsightViewOption.THINGS:
        return generateThingsInsightStrategy()

      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption])

const useDecoratedSearchFilterComposingStrategy = (widgetSetting: SideBySideWidgetsType) => {
  const { viewOption, pivotThemeInfos, tagNames, docNames } = widgetSetting

  const searchFilterComposingStrategy = useSearchFilterComposingStrategy(viewOption!)

  if (pivotThemeInfos && pivotThemeInfos.length > 0) {
    return pivotThemeDecorator(searchFilterComposingStrategy)
  }

  if (tagNames && tagNames.length > 0) {
    return pivotTagDecorator(searchFilterComposingStrategy)
  }

  if (docNames && docNames.length > 0) {
    return pivotProductDecorator(searchFilterComposingStrategy)
  }

  return searchFilterComposingStrategy
}

export default useDecoratedSearchFilterComposingStrategy
